var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 167,
    fill: "none",
    viewBox: "0 0 160 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#684199",
    strokeLinejoin: "round",
    d: "M107.245 179.681c-12.624 1.127-37.911-1.465-60.192-5.222-19.801-3.232-37.423-8.041-42.796-14.767-5.148-6.462-4.171-24.197-1.992-43.623.864-7.815 2.03-15.856 2.931-23.708l6.388-56.736C13.5 18.717 16.205 1.17 23.644-3.64c15.443-9.994 76.05-8.566 101.749 1.466 19.839 7.59 33.328 23.896 33.366 41.819 0 16.081-8.116 33.553-16.72 37.423 9.806 8.266 18.26 26.076 16.119 45.239-3.495 31.035-19.388 54.256-50.875 57.374zM82.672 48.475c4.284.488 9.13-1.804 9.694-6.576.076-.751-.075-1.54-.187-2.818-.865-3.682-3.457-5.748-6.463-6.087-4.283-.488-8.943 2.33-9.469 6.876l-.187 1.766c.263 4.359 3.344 6.5 6.65 6.876zM75.12 127.04c4.02.451 9.13-1.766 9.657-6.313.112-1.014-.038-1.803-.188-2.818-1.09-3.945-3.945-5.823-6.989-6.162-4.02-.45-8.905 2.067-9.468 6.876-.076.489.15 1.052.075 1.541.263 4.621 3.344 6.5 6.876 6.913z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleB);
export default __webpack_public_path__ + "static/media/purpleB.b199c55d5e4e9ead0011df90f7b18c85.svg";
export { ForwardRef as ReactComponent };